import { Component, Input, OnInit } from '@angular/core';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { ModalController } from '@ionic/angular';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { calculateLode, getToastPosition, gramsToOz, ozToGrams } from '../../../angular-wallet-base/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { BUY_METALS_MAXIMUM_OZ_GOLD, BUY_METALS_MAXIMUM_OZ_SILVER } from '../../../angular-wallet-base/constants';

type MetalType = 'gold' | 'silver';
interface CardOrder {
  grams: number;
  oz: number;
  metal_type: MetalType;
  user_message: string;
}
interface MetalData {
  id: string;
  notes: string;
  qty: number;
  type: MetalType;
  weight: number;
  category: string;
}
@Component({
  selector: 'app-add-metal',
  templateUrl: './add-metal.component.html',
  styleUrls: ['./add-metal.component.scss'],
})
export class AddMetalComponent implements OnInit {
  @Input() editValue: MetalData;
  public isDesktopMode: any;
  public form: FormGroup;
  public cart = [];
  public qtyTotal = 0;
  public ozTotal = 0;
  public lodeTotal = 0;
  public lodeTotalMin = 0;
  public lodeTotalMax = 0;
  public exchangeRate = 0;
  public itemArr = [];
  public lodeRateGrams: any;
  public currentValue = '';
  allTotalValues: { totalOz: number; totalQty: number; };
  public title;
  public btn_title;
  public ozMaximum = 100;
  constructor(private appMode: AppModeService,
    private modal: ModalController,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    await this.initForm();
    if (this.editValue) {
      this.setValueInEdit();
      this.title = await this.translate.get("buy_assets.edit_your_metal").toPromise();
      this.btn_title = await this.translate.get("buy_assets.edit_metal_btn").toPromise();
    } else {
      this.title = await this.translate.get("buy_assets.add_your_metal").toPromise();
      this.btn_title = await this.translate.get("buy_assets.add_metal_btn").toPromise();
    }
    this.form.controls['type'].valueChanges.subscribe(value => {
      if (value === 'gold') {
        this.ozMaximum = BUY_METALS_MAXIMUM_OZ_GOLD;
      } else {
        this.ozMaximum = BUY_METALS_MAXIMUM_OZ_SILVER;
      }
    });
  }
  async setValueInEdit() {
    await this.form.patchValue({
      type: this.editValue['type'] || '',
      category: this.editValue['category'] || '',
      qty: this.editValue['qty'] || '',
      weight: this.editValue['weight'] || '',
      notes: this.editValue['notes'] || '',
      id: this.editValue['id']
    });
    this.ozMaximum = this.editValue['type'] === 'gold' ? BUY_METALS_MAXIMUM_OZ_GOLD : BUY_METALS_MAXIMUM_OZ_SILVER;
  }
  initForm() {
    this.form = this.formBuilder.group({
      type: ['', Validators.required],
      category: ['', Validators.required],
      qty: ['', Validators.compose([Validators.required, Validators.min(0)])],
      weight: ['', Validators.compose([Validators.required, Validators.min(0)])],
      notes: [''],
      id: ['']
    });
  }
  addItemToCard() {
    if (this.form.invalid) {
      return;
    }

    const item = {
      id: this.editValue ? this.editValue['id'] : Math.random().toString(16),
      type: this.form.get('type').value,
      category: this.form.get('category').value,
      qty: this.form.get('qty').value,
      weight: this.form.get('weight').value,
      notes: this.form.get('notes').value
    };
    this.cart.push(item);
    this.calculateCart();
    this.initForm();
    Logger.info(this.cart)
    this.modal.dismiss(this.cart);
  }
  calculateCart() {
    this.qtyTotal = 0;
    this.ozTotal = 0;
    this.lodeTotal = 0;
    this.itemArr = [];
    this.cart.forEach(item => {

      // Calculate Quantity total
      this.qtyTotal = this.qtyTotal + parseFloat(item.qty);
      // Calculate Oz total
      this.ozTotal = this.ozTotal + parseFloat(item.weight);
      // Calculate the Total Weight
      let totalWeight = (parseFloat(item.qty) * parseFloat(item.weight));
      // Building object to send
      var itemObj: CardOrder = {
        grams: ozToGrams(totalWeight),
        oz: totalWeight,
        metal_type: item.type,
        user_message: item.notes
      }
      this.itemArr.push(itemObj);
      // Calculate LODE total
      this.lodeTotal = this.lodeTotal + calculateLode(parseFloat(item.weight), parseFloat(item.qty), item.type, this.lodeRateGrams);

    });

    // Adding 1% 
    this.lodeTotalMax = this.lodeTotal + (this.lodeTotal * 0.01);
    // Subst 1%
    this.lodeTotalMin = this.lodeTotal - (this.lodeTotal * 0.01);

  }
  get f() { return this.form.controls; }

  isAddingDisabled() {
    return !this.form.valid;
  }
  showRequiredError(field, input?) {
    if (this.form.controls[field].errors && this.form.get(field).touched) {
      return input ? true : '*Required';
    }
  }
  onCancel() {
    this.modal.dismiss();
  }
}
